module.exports = __webpack_public_path__ + "static/media/footer.01c6a3f8.jpg";